import { useMediaProps } from './media-props';

const queries = {
  desktop: `(min-width: 1024px)`,
  tablet: `(min-width: 660px) and (max-width: 1023px)`,
};

export type SizeType = 'small' | 'medium' | 'large';

export function useSize(): SizeType {
  return useMediaProps({
    all: {
      size: 'small',
    },
    [queries.tablet]: { size: 'medium' },
    [queries.desktop]: { size: 'large' },
  }).size;
}
